import { createGlobalStyle } from "styled-components";
import { reset } from "styled-reset";

const GlobalStyles = createGlobalStyle`
/* reset */
${reset}

* {
	box-sizing: border-box;
}

html, body {
	margin: 0;
	padding: 0;
	width: 100%;
	height: 100%;
	min-height: 100vh;
	min-height: -webkit-fill-available;
	color: ${({ theme }) => theme.color.primary};
	font-family: "Apple SD Gothic Neo", -apple-system, BlinkMacSystemFont, "Roboto", Arial, Helvetica, sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: initial;
	-webkit-text-size-adjust: none;
	-webkit-overflow-scrolling: touch;
	overflow-x: hidden;
}

#root {
	width: 100%;
	height: 100%;
	overflow-x: hidden;
}

/* Container */
.vmd-container {
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	width: 100%;
	height: 100vh;
	overflow-x: hidden;
}

.vmd-contents {
	flex: 1;
}

button {
	outline: none;
}

input:focus {
	outline: none;
	-webkit-text-size-adjust: none;
}

${/* 위의 두 규칙이 마우스 테두리와 함께 키보드 포커스 표시까지 지워, 키보드만 쓰는
     사용자가 자기 위치를 볼 수 없었다. :focus-visible 은 마우스 클릭에는 맞지 않으므로
     마우스 동작은 그대로 두고 키보드 경로에만 표시를 돌려준다.
     input:focus 와 명시도가 같으니 반드시 그 뒤에 와야 한다.
     tabindex="-1" 은 뺀다. Tab 으로 닿지 않는 자리라 길잡이가 필요 없고, 모달이
     포커스를 강제로 옮길 때 엉뚱한 테두리가 그려진다.
     CSS 주석으로 두면 템플릿 리터럴 내용이라 운영 번들에 한글이 그대로 실린다.
     JS 주석 자리로 올리고 빈 문자열을 끼워 넣어 내보내지 않는다. */ ""}
button:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible,
a:focus-visible,
[tabindex]:not([tabindex="-1"]):focus-visible {
	outline: 2px solid ${({ theme }) => theme.color.subMain};
	outline-offset: 2px;
}

a {
	color: inherit;
	text-decoration: none;
}

img {
	vertical-align: middle;
}

svg {
	vertical-align: middle;
}

*, *::before, *::after {
	box-sizing: border-box;
	-webkit-tap-highlight-color: rgba(255,255,255,0);
}

.hidden {
	overflow:hidden;
	position: absolute;
  display:inline-block;
	border:0;
	width:1px;
	height:1px;
	clip: rect(1px, 1px, 1px, 1px);
	clip-path:inset(50%);
}

/* Header */
header {
	z-index: 999;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	${({ theme }) => theme.flexBox.flexMixin()};
	/* height: 50px; */
	padding: 20px 15px 12px;
	padding-top: calc(${({ theme }) => theme.mobile.notchHeight}px + 20px);
	background-color: #fff;
	transition: all 0.5s;
	&.sub-top {
		background-color: rgba(255,255,255,0.7);
	}
	&.main-scrolled {
		background-color: rgba(255,255,255,0.8);
	}
	.logo {
		> a {
			display: inline-block;
		}
	}
	@keyframes blink-effect {
		50% {
			opacity: 0;
		}
	}
	.blink {
		animation: blink-effect 1.3s step-end infinite;
		color: #d10000;
		font-size: 20px;
		font-weight: 700;
	}
	.btn-box {
		> button:last-child {
			margin-left: 12px;
		}
	}
	.alarm {
		position: relative;
	}
	&.hasAlarm {
		.alarm::after {
			content: "";
			position: absolute;
			top: 5px;
			right: 3px;
			display: inline-block;
			width: 7px;
			height: 7px;
			border-radius: 4px;
			background-color: ${({ theme }) => theme.color.warning};
		}
	}
}

${/* BottomModal 효과 */ ""}
.bottomModal-enter {
	.modal-wrap {
		transform: translate(0, 100%);
	}
}

.bottomModal-enter-active {
	.modal-wrap {
		transform: translate(0);
    transition: transform 400ms cubic-bezier(0, 0, 0.2, 1), opacity 300ms;
	}
}

.bottomModal-exit {
	.modal-wrap {
		transform: translate(0);
		bottom: 0;
	}
}

.bottomModal-exit-active {
	.modal-wrap {
		transform: translate(0, 100%);
    transition: transform 400ms ease-in-out, opacity 300ms;
	}
}

${/* Modal 효과 */ ""}
.modal-enter {
	.modal-wrap {
		transform: scale(0.95);
	}
}

.modal-enter-active {
	.modal-wrap {
    /* opacity: 1; */
		transform: scale(1);
    transition: transform 300ms cubic-bezier(0, 0, 0.2, 1), opacity 300ms;
	}
}

.modal-exit {
	.modal-wrap {
    /* opacity: 1; */
		transform: scale(1);
	}
}

.modal-exit-active {
	.modal-wrap {
		/* opacity: 0.5; */
		transform: scale(0.95);
    transition: transform 300ms linear, opacity 300ms;
	}
}

${/* 공통 타이틀 */ ""}
.common-title {
	color: #000;
	&.col-white {
		color: #fff;
	}
	.tag {
		margin-bottom: 8px;
		${({ theme }) => theme.fontFamily.appleGothicNeo("regular", 400)};
		font-size: 16px;
		text-transform: uppercase;
	}
	.title-wrap {
		${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-end")};
		&.title {
			margin-bottom: 24px;
			h3 {
				${({ theme }) => theme.fontFamily.appleGothicNeo("light", 300)};
				font-size: 24px;
			}
		}
		&.sub-title {
			margin-bottom: 16px;
			p {
				font-size: 16px;
			}
		}
		.num {
			margin-bottom: 3px;
			color: ${({ theme }) => theme.color.tertiary};
			font-size: 12px;
		}
	}
}
`;

export default GlobalStyles;
